var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details-view" },
    [
      _c(
        "cargo-left-right-resize",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: Boolean(_vm.action),
              expression: "Boolean(action)"
            }
          ],
          staticStyle: { "min-height": "100%" },
          attrs: {
            "left-style": {
              flex: "none",
              "min-width": "180px",
              "max-width": "220px"
            },
            "right-style": { overflow: "hidden" },
            "show-left": _vm.action === "look"
          }
        },
        [
          _c(
            "template",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.action === "look",
                  expression: "action==='look'"
                }
              ],
              slot: "left"
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "min-width": "180px",
                    width: "100%",
                    height: "100%",
                    padding: "10px 0px 10px"
                  }
                },
                [
                  _c("cargo-ag-grid", {
                    staticClass: "section",
                    staticStyle: {
                      "min-width": "160px",
                      width: "100%",
                      height: "100%"
                    },
                    attrs: {
                      "show-side-bar": false,
                      "grid-options": _vm.gridOptions,
                      "row-data": _vm.rowData,
                      "check-sub-record": false,
                      "check-main-record": false,
                      "deselect-main-record": false,
                      "deselect-sub-record": false
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              )
            ]
          ),
          _c("template", { slot: "right" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                {
                  staticClass: "operations",
                  staticStyle: { "margin-bottom": "5px" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "triggers" },
                    [
                      _c("cargo-button-group-slider", [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.action === "look",
                                expression: "action==='look'"
                              }
                            ]
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { no: "1", type: "primary" },
                                on: {
                                  click: function($event) {
                                    _vm.backEventFlag = true
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.back")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "2",
                                  disabled: !(
                                    _vm.currentRow &&
                                    _vm.currentRow.jobState == -1 &&
                                    !_vm.isEditing
                                  ),
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.onAdd()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.$checkPermission([
                                      "button_fmVerify_edit"
                                    ]),
                                    expression:
                                      "$checkPermission(['button_fmVerify_edit'])"
                                  }
                                ],
                                attrs: { no: "3", type: "success" },
                                on: { click: _vm.toEdit }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "4",
                                  disabled: !(
                                    _vm.currentRow &&
                                    _vm.currentRow.jobState === -1 &&
                                    !_vm.isEditing
                                  ),
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.copyJobHandler()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Clone")))]
                            ),
                            _vm.isHc &&
                            _vm.job.prePortPlanner > 0 &&
                            _vm.job.prePortApproveStatus ===
                              _vm.SystemConstants.PRICE_STATE_REVIEW.code &&
                            (_vm.$store.getters.isAdmin ||
                              _vm.$store.getters.userId ===
                                _vm.job.prePortPlanner)
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "showPrePortAuditBtn",
                                      type: "primary"
                                    },
                                    on: {
                                      click: function(p) {
                                        _vm.priceAuditCommand = _vm.$t(
                                          "CargoMsg.Cargo_preportAudit"
                                        )
                                        _vm.priceAuditHandle()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_preportAudit")
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm.isHc &&
                            _vm.job.planner > 0 &&
                            _vm.job.trunkLineApproveStatus ===
                              _vm.SystemConstants.PRICE_STATE_REVIEW.code &&
                            (_vm.$store.getters.isAdmin ||
                              _vm.$store.getters.userId === _vm.job.planner)
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "showTrunkLineAuditBtn",
                                      type: "primary"
                                    },
                                    on: {
                                      click: function(p) {
                                        _vm.priceAuditCommand = _vm.$t(
                                          "CargoMsg.Cargo_TrunkLineAudit"
                                        )
                                        _vm.priceAuditHandle()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_TrunkLineAudit")
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm.isHc &&
                            _vm.job.prePortPlanner > 0 &&
                            _vm.job.lastMileApproveStatus ===
                              _vm.SystemConstants.PRICE_STATE_REVIEW.code &&
                            (_vm.$store.getters.isAdmin ||
                              _vm.$store.getters.userId ===
                                _vm.job.lastMilePlanner)
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "showLastMileAuditBtn",
                                      type: "primary"
                                    },
                                    on: {
                                      click: function(p) {
                                        _vm.priceAuditCommand = _vm.$t(
                                          "CargoMsg.Cargo_TailEndAudit"
                                        )
                                        _vm.priceAuditHandle()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_TailEndAudit")
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.$checkPermission([
                                        "button_fmVerify_accept"
                                      ]) && !_vm.isCooperate,
                                    expression:
                                      "$checkPermission(['button_fmVerify_accept']) && !isCooperate"
                                  }
                                ],
                                attrs: {
                                  no: "5",
                                  disabled: !(
                                    _vm.currentRow &&
                                    _vm.currentRow.jobState === -1 &&
                                    !_vm.isEditing &&
                                    _vm.btn.acceptRole &&
                                    _vm.currentRow.preverifyState !== 5 &&
                                      _vm.currentRow.preverifyState !== 2 &&
                                      _vm.currentRow.preverifyState !== 3
                                  ),
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.acceptHandler(1)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.PassAudit")))]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.$checkPermission([
                                        "button_fmVerify_reject"
                                      ]) && !_vm.isCooperate,
                                    expression:
                                      "$checkPermission(['button_fmVerify_reject']) && !isCooperate"
                                  }
                                ],
                                attrs: {
                                  no: "6",
                                  disabled: !(
                                    _vm.currentRow &&
                                    _vm.currentRow.jobState === -1 &&
                                    !_vm.isEditing &&
                                    _vm.btn.rejectRole &&
                                    _vm.currentRow.preverifyState !== 5 &&
                                      _vm.currentRow.preverifyState !== 2 &&
                                      _vm.currentRow.preverifyState !== 3
                                  ),
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.rejectHandler(1)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Refuse")))]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.$checkPermission([
                                        "button_fmVerify_accept"
                                      ]) && _vm.isCooperate,
                                    expression:
                                      "$checkPermission(['button_fmVerify_accept']) && isCooperate"
                                  }
                                ],
                                attrs: {
                                  no: "7",
                                  disabled: !(
                                    _vm.currentRow &&
                                    !_vm.isEditing &&
                                    _vm.btn.acceptRole &&
                                    [
                                      _vm.SystemConstants
                                        .COOPERATE_STATUS_PENDING.code
                                    ].includes(_vm.currentRow.cooperateStatus)
                                  ),
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.acceptCooperateHandler(1)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.PassAudit")))]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.$checkPermission([
                                        "button_fmVerify_reject"
                                      ]) && _vm.isCooperate,
                                    expression:
                                      "$checkPermission(['button_fmVerify_reject']) && isCooperate"
                                  }
                                ],
                                attrs: {
                                  no: "8",
                                  disabled: !(
                                    _vm.currentRow &&
                                    !_vm.isEditing &&
                                    _vm.btn.rejectRole &&
                                    [
                                      _vm.SystemConstants
                                        .COOPERATE_STATUS_PENDING.code
                                    ].includes(_vm.currentRow.cooperateStatus)
                                  ),
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.rejectHandler(1)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Refuse")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "9",
                                  disabled: _vm.btn.enablePrint,
                                  type: "primary"
                                },
                                on: { click: _vm.onPrint }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.print")))]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.$checkPermission([
                                        "button_fmVerify_reviewThrough"
                                      ]) &&
                                      _vm.btn.pretrialReviewConfig &&
                                      !_vm.isCooperate,
                                    expression:
                                      "$checkPermission(['button_fmVerify_reviewThrough']) && btn.pretrialReviewConfig && !isCooperate"
                                  }
                                ],
                                attrs: {
                                  no: "10",
                                  disabled: !(
                                    _vm.currentRow &&
                                    _vm.currentRow.jobState === -1 &&
                                    !_vm.isEditing &&
                                    _vm.btn.pretrialReviewThroughRole &&
                                    _vm.btn.pretrialReviewConfig &&
                                    _vm.currentRow.preverifyState === 2
                                  ),
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.btVerifyReviewThroughHandler(1)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.VerifyReviewThrough")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.$checkPermission([
                                        "button_fmVerify_reviewRefusal"
                                      ]) &&
                                      _vm.btn.pretrialReviewConfig &&
                                      !_vm.isCooperate,
                                    expression:
                                      "$checkPermission(['button_fmVerify_reviewRefusal']) && btn.pretrialReviewConfig && !isCooperate"
                                  }
                                ],
                                attrs: {
                                  no: "11",
                                  disabled: !(
                                    _vm.currentRow &&
                                    _vm.currentRow.jobState === -1 &&
                                    !_vm.isEditing &&
                                    _vm.btn.pretrialReviewRefusalRole &&
                                    _vm.btn.pretrialReviewConfig &&
                                    _vm.currentRow.preverifyState === 2
                                  ),
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.btVerifyReviewRefusalHandler(1)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.VerifyReviewRefusal")
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isNew,
                                expression: "isNew"
                              }
                            ],
                            staticClass: "new",
                            staticStyle: {
                              "border-left": "none",
                              "padding-left": "0"
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { no: "12", type: "success" },
                                on: { click: _vm.save }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { no: "13", type: "success" },
                                on: {
                                  click: function($event) {
                                    return _vm.cancelEdit(
                                      _vm.openMultiple
                                        ? _vm.goBackAtMultiple
                                        : _vm.goBack
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "SaveTheDefaultValues",
                                  type: "primary"
                                },
                                on: { click: _vm.saveDefaultVal }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.SaveTheDefaultValues")
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.action === "edit",
                                expression: "action==='edit'"
                              }
                            ],
                            staticClass: "btn-group-edit",
                            staticStyle: {
                              "border-left": "none",
                              "padding-left": "0"
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { no: "14", type: "success" },
                                on: { click: _vm.save }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { no: "15", type: "success" },
                                on: {
                                  click: function($event) {
                                    return _vm.cancelEdit(
                                      _vm.openMultiple
                                        ? _vm.againLookAtMultiple
                                        : _vm.lookHandler
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "SaveTheDefaultValues2",
                                  type: "primary"
                                },
                                on: { click: _vm.saveDefaultVal }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.SaveTheDefaultValues")
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.action === "look" || _vm.action === "edit",
                              expression: "action==='look'||action==='edit'"
                            }
                          ],
                          staticStyle: {
                            display: "flex",
                            "white-space": "nowrap"
                          }
                        },
                        [
                          _c("CargoIm", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.imCacheKey && _vm.action === "look",
                                expression: "imCacheKey && action==='look'"
                              }
                            ],
                            ref: "cargoIm"
                          }),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: _vm.$t("SeaExport.Tip2"),
                                placement: "bottom-start"
                              }
                            },
                            [
                              _c("img", {
                                staticStyle: {
                                  width: "20px",
                                  "margin-right": "5px"
                                },
                                attrs: { src: _vm.locationImg },
                                on: { click: _vm.toQueryDataPushLog }
                              })
                            ]
                          ),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content:
                                  _vm.action === "edit"
                                    ? ""
                                    : _vm.$t("SeaExport.Tip1"),
                                placement: "bottom-start",
                                offset: _vm.sopTooltipOffset,
                                "visible-arrow": false
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "100%",
                                    cursor: "pointer"
                                  },
                                  on: {
                                    mousemove: _vm.resetSopTooltip,
                                    dblclick: function($event) {
                                      return _vm.onBtnListDoubleClicked()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "red",
                                      staticStyle: {
                                        "font-size": "14px",
                                        padding: "5px 0"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.commonInfo.jobState))]
                                  ),
                                  _c("span", {
                                    staticStyle: {
                                      "font-size": "12px",
                                      padding: "5px 9px",
                                      color: "unset"
                                    },
                                    domProps: {
                                      innerHTML: _vm._s(_vm.commonInfo.jobTitle)
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "red",
                                      staticStyle: {
                                        "font-size": "12px",
                                        padding: "5px 0"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.commonInfo.jobLock))]
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "tabs-container" },
                [
                  _c(
                    "el-tabs",
                    {
                      ref: "tabs",
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "card",
                        "before-leave": function(activeName, oldActiveName) {
                          _vm.beforeLeaveTab(activeName, oldActiveName)
                        }
                      },
                      on: { "tab-click": _vm.handleTabClick },
                      model: {
                        value: _vm.activeTabName,
                        callback: function($$v) {
                          _vm.activeTabName = $$v
                        },
                        expression: "activeTabName"
                      }
                    },
                    [
                      !_vm.masterFlag &&
                      (_vm.privilege.seBooking.bookingTab || _vm.isVerify)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 1,
                              attrs: {
                                lazy: true,
                                name: "tabBookingFCL",
                                label: _vm.$t("SeaExport.Basic")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable
                                ? _c("tab-booking-FCLUICustom", {
                                    ref: "tabBookingFCL",
                                    attrs: {
                                      "slave-customs-declaration-enable":
                                        _vm.slaveCustomsDeclarationEnable,
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "processing-promise-list":
                                        _vm.processingPromiseList
                                    }
                                  })
                                : _c("tab-booking-fcl", {
                                    ref: "tabBookingFCL",
                                    attrs: {
                                      "slave-customs-declaration-enable":
                                        _vm.slaveCustomsDeclarationEnable,
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "processing-promise-list":
                                        _vm.processingPromiseList
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.masterFlag &&
                      (_vm.privilege.seBooking.bookingTab || _vm.isVerify)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 2,
                              attrs: {
                                lazy: true,
                                name: "tabBookingMaster",
                                label: _vm.$t("SeaExport.Basic")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable
                                ? _c("tab-booking-master-UICustom", {
                                    ref: "tabBookingMaster",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "is-sea-export": true,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "view-source": "bookingWorkspace",
                                      "processing-promise-list":
                                        _vm.processingPromiseList
                                    },
                                    on: {
                                      addLcl: _vm.addBatchLcl,
                                      selectJob: function(jobUuid) {
                                        _vm.transferTargetRow("edit", jobUuid)
                                      },
                                      addSlavedJob: _vm.addSlavedJob,
                                      removeJobFromMaster:
                                        _vm.removeJobFromMaster,
                                      removeJob: _vm.removeJob
                                    }
                                  })
                                : _c("tab-booking-master", {
                                    ref: "tabBookingMaster",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "is-sea-export": true,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "view-source": "bookingWorkspace",
                                      "processing-promise-list":
                                        _vm.processingPromiseList
                                    },
                                    on: {
                                      addLcl: _vm.addBatchLcl,
                                      selectJob: function(jobUuid) {
                                        _vm.transferTargetRow("edit", jobUuid)
                                      },
                                      addSlavedJob: _vm.addSlavedJob,
                                      removeJobFromMaster:
                                        _vm.removeJobFromMaster,
                                      removeJob: _vm.removeJob
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      (_vm.privilege.seBooking.vesselEqTab ||
                        _vm.privilege.salesQueryModule.vesselEqTab ||
                        _vm.isVerify)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 3,
                              attrs: {
                                lazy: true,
                                name: "tabVesselEq",
                                label: _vm.$t("SeaExport.Booking")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable
                                ? _c("tab-vessel-eq-UICustom", {
                                    ref: "tabVesselEq",
                                    attrs: {
                                      "slave-customs-declaration-enable":
                                        _vm.slaveCustomsDeclarationEnable,
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit":
                                        _vm.cooperateEditBooking,
                                      "view-source": "verifyWorkspace"
                                    }
                                  })
                                : _c("tab-vessel-eq", {
                                    ref: "tabVesselEq",
                                    attrs: {
                                      "slave-customs-declaration-enable":
                                        _vm.slaveCustomsDeclarationEnable,
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit":
                                        _vm.cooperateEditBooking,
                                      "view-source": "verifyWorkspace"
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.masterFlag && _vm.paramsOfTab.usCustomsClearance
                        ? _c(
                            "el-tab-pane",
                            {
                              key: "tabUsCustomsClearance",
                              attrs: {
                                lazy: true,
                                name: "tabUsCustomsClearance",
                                label: _vm.$t("queryJob.UsCustomsClearance")
                              }
                            },
                            [
                              _c("tab-us-customs-clearance", {
                                ref: "tabUsCustomsClearance",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: { syncData: _vm.syncData }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.masterFlag && _vm.paramsOfTab.usCustomsClearance
                        ? _c(
                            "el-tab-pane",
                            {
                              key: "tabUsCustomsClearanceMaster",
                              attrs: {
                                lazy: true,
                                name: "tabUsCustomsClearanceMaster",
                                label: _vm.$t("queryJob.UsCustomsClearance")
                              }
                            },
                            [
                              _c("tab-us-customs-clearance-master", {
                                ref: "tabUsCustomsClearanceMaster",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: { syncData: _vm.syncData }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      (_vm.masterFlag || _vm.paramsOfTab.signMBL) &&
                      _vm.privilege.seBooking.mbl
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 4,
                              attrs: {
                                lazy: true,
                                name: "tabMBL",
                                label: "MB/L"
                              }
                            },
                            [
                              _c("tab-mbl", {
                                ref: "tabMBL",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: { resetTab: _vm.resetTab }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.isNew &&
                      _vm.privilege.seBooking.mbl2 &&
                      _vm.paramsOfTab.typeMBL !== 0 &&
                        _vm.paramsOfTab.typeMBL !== 1
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 5,
                              attrs: {
                                lazy: true,
                                name: "tabMBL2",
                                label:
                                  "MB/L" +
                                  (_vm.paramsOfTab.typeMBL === 2
                                    ? _vm.$t("CargoMsg.Cargo_SplitBL")
                                    : "") +
                                  (_vm.paramsOfTab.typeMBL === 3
                                    ? _vm.$t("SeaExport.MergeAndSingle")
                                    : "")
                              }
                            },
                            [
                              _c("tab-mbl2", {
                                ref: "tabMBL2",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: { syncData: _vm.syncData }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.paramsOfTab.signHBL &&
                      !_vm.paramsOfTab.mblOnly &&
                      !_vm.masterFlag &&
                      _vm.privilege.seBooking.hbl
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 6,
                              attrs: {
                                lazy: true,
                                name: "tabHBL",
                                label: "HB/L"
                              }
                            },
                            [
                              _c("tab-hbl", {
                                ref: "tabHBL",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: {
                                  resetTab: _vm.resetTab,
                                  syncData: _vm.syncData
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.paramsOfTab.mblOnly &&
                      !_vm.isNew &&
                      _vm.privilege.seBooking.hbl2 &&
                      _vm.paramsOfTab.typeHBL !== 0 &&
                        _vm.paramsOfTab.typeHBL !== 1
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 7,
                              attrs: {
                                lazy: true,
                                name: "tabHBL2",
                                label:
                                  "HB/L" +
                                  (_vm.paramsOfTab.typeHBL === 2
                                    ? _vm.$t("CargoMsg.Cargo_SplitBL")
                                    : "") +
                                  (_vm.paramsOfTab.typeHBL === 3
                                    ? _vm.$t("SeaExport.MergeAndSingle")
                                    : "")
                              }
                            },
                            [
                              _c("tab-hbl2", {
                                ref: "tabHBL2",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: { syncData: _vm.syncData }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.paramsOfTab.warehousing &&
                      _vm.privilege.seBooking.warehouseTab
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 8,
                              attrs: {
                                lazy: true,
                                name: "tabWarehouse",
                                label: _vm.$t("SeaExport.WarehouseLoading")
                              }
                            },
                            [
                              _c("tab-warehouse", {
                                ref: "tabWarehouse",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditWarehouse
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.paramsOfTab.landTransportation &&
                      _vm.privilege.seBooking.seTruckingPage
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 9,
                              attrs: {
                                lazy: true,
                                name: "tabTruckingForSe",
                                label: _vm.$t("SeaExport.Trucking")
                              }
                            },
                            [
                              _c("tab-trucking-for-se", {
                                ref: "tabTruckingForSe",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditTrucking
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.dischargingPortDoor
                        ? _c(
                            "el-tab-pane",
                            {
                              key: "tabDischargingTrucking",
                              attrs: {
                                lazy: true,
                                name: "tabDischargingTrucking",
                                label: _vm.$t(
                                  "SeaExport.DispatchVehiclesAtDestination"
                                )
                              }
                            },
                            [
                              _c("tab-discharging-trucking", {
                                ref: "tabDischargingTrucking",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.destPortCustomsClearance
                        ? _c(
                            "el-tab-pane",
                            {
                              key: "tabDestinationCustomsData",
                              attrs: {
                                lazy: true,
                                name: "tabDestinationCustomsData",
                                label: _vm.$t(
                                  "SeaExport.PortOfDestinationCustomsClearance"
                                )
                              }
                            },
                            [
                              _c("tab-destination-customs-data", {
                                ref: "tabDestinationCustomsData",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "force-readonly": true
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.masterFlag &&
                      _vm.privilege.seBooking.containersLayer
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 10,
                              attrs: {
                                lazy: true,
                                name: "tabContainer",
                                label: _vm.$t("SeaExport.ContainerInfo")
                              }
                            },
                            [
                              _c("tab-container", {
                                ref: "tabContainer",
                                attrs: {
                                  "slave-customs-declaration-enable":
                                    _vm.slaveCustomsDeclarationEnable,
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.masterFlag &&
                      !_vm.isNew &&
                      _vm.privilege.seBooking.lclManagerLayer
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 11,
                              attrs: {
                                lazy: true,
                                name: "tabLclContainer",
                                label: _vm.$t("SeaExport.ContainerInfo")
                              }
                            },
                            [
                              _vm.masterCustomsDeclarationEnable
                                ? _c("tab-lcl-container-multi-so-no-mode", {
                                    ref: "tabLclContainer",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    },
                                    on: {
                                      addSlavedJob: _vm.addSlavedJob,
                                      removeJobFromMaster:
                                        _vm.removeJobFromMaster,
                                      split: _vm.splitHandle
                                    }
                                  })
                                : _c("tab-lcl-container", {
                                    ref: "tabLclContainer",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    },
                                    on: {
                                      addSlavedJob: _vm.addSlavedJob,
                                      removeJobFromMaster:
                                        _vm.removeJobFromMaster,
                                      split: _vm.splitHandle
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.isNew &&
                      _vm.paramsOfTab.ams &&
                      !_vm.masterFlag &&
                      _vm.privilege.seBooking.ams
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 12,
                              attrs: {
                                lazy: true,
                                name: "tabAMS",
                                label: "AMS/ENS"
                              }
                            },
                            [
                              _c("tab-ams", {
                                ref: "tabAMS",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.privilege.charge.chargeView
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 13,
                              attrs: {
                                lazy: true,
                                name: "tabCharges",
                                label: _vm.$t("SeaExport.Charge")
                              }
                            },
                            [
                              _c("tab-charges", {
                                ref: "tabCharges",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "view-source": "BookingVerify"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.isNew &&
                      _vm.privilege.chargeConfirm.chargeConfirmView
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 14,
                              attrs: {
                                lazy: true,
                                name: "tabInternalBill",
                                label: _vm.$t("SeaExport.InternalBillInfo")
                              }
                            },
                            [
                              _c("tab-internal-bill", {
                                ref: "tabInternalBill",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.isNew &&
                      _vm.privilege.billTab.billTabView
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 15,
                              attrs: {
                                lazy: true,
                                name: "tabOverseaBill",
                                label: _vm.$t("SeaExport.OverseaBillInfo")
                              }
                            },
                            [
                              _c("tab-oversea-bill", {
                                ref: "tabOverseaBill",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "view-source": "BookingVerify"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.isNew &&
                      _vm.privilege.seBooking.fileTab
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 16,
                              attrs: {
                                lazy: true,
                                name: "tabFile",
                                label: _vm.$t("SeaExport.DocumentCirculation")
                              }
                            },
                            [
                              _c("tab-file", {
                                ref: "tabFile",
                                attrs: {
                                  context: _vm.context,
                                  "cooperate-edit": _vm.cooperateEditOther
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.masterFlag &&
                      _vm.paramsOfTab.cargoType &&
                      _vm.paramsOfTab.cargoType !== "GC" &&
                      _vm.privilege.seBooking.specialGoodsTab
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 17,
                              attrs: {
                                lazy: true,
                                name: "tabSpecialGoods",
                                label: _vm.$t("SpecialGoods.label")
                              }
                            },
                            [
                              _c("tab-special-goods", {
                                ref: "tabSpecialGoods",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.privilege.seBooking.portalState &&
                      !_vm.isNew
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 18,
                              attrs: {
                                lazy: true,
                                name: "tabSopState",
                                label: _vm.$t("SeaExport.BusinessStatus")
                              }
                            },
                            [
                              _c("tab-sop-state", {
                                ref: "tabSopState",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther,
                                  "sop-template-config": _vm.sopTemplateConfig
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.isNew &&
                      _vm.privilege.fileHistory.fileHistoryView
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 19,
                              attrs: {
                                lazy: true,
                                name: "tabFileHistory",
                                label: _vm.$t("SeaExport.FileHistory")
                              }
                            },
                            [
                              _c("tab-file-history", {
                                ref: "tabFileHistory",
                                attrs: {
                                  context: _vm.context,
                                  "cooperate-edit": _vm.cooperateEditOther
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        2
      ),
      _c("cargo-template-selector-dialog", {
        ref: "templateSelectorDialog",
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: _vm.context,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _vm.dataPushDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              staticClass: "app-main-inner",
              attrs: {
                visible: _vm.dataPushDialog.visible,
                title: _vm.$t("SeaExport.DataPushChangeLog"),
                width: "580px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.dataPushDialog, "visible", $event)
                },
                close: function($event) {
                  _vm.dataPushDialog.visible = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: {
                    padding: "0",
                    display: "flex",
                    "flex-direction": "column"
                  },
                  style: { width: "100%", height: "400px", overflow: "auto" }
                },
                _vm._l(_vm.dataPushDialog.titles, function(title, index) {
                  return _c(
                    "div",
                    { key: index },
                    [
                      _c("div", { staticStyle: { background: "#EBECF5" } }, [
                        _c("b", [_vm._v(_vm._s(title))])
                      ]),
                      _vm._l(_vm.dataPushDialog.dataMap.get(title), function(
                        item,
                        index
                      ) {
                        return _c("div", { key: index }, [
                          _c("div", [_vm._v(_vm._s(item))])
                        ])
                      })
                    ],
                    2
                  )
                }),
                0
              )
            ]
          )
        : _vm._e(),
      _c("sop-state-dialog", {
        attrs: {
          "hide-window": _vm.isEditing,
          visible: _vm.sopStateDialog.visible,
          "is-need-refresh": _vm.sopStateDialog.isNeedRefresh,
          "default-is-expand": _vm.sopStateDialog.defaultIsExpand,
          job: _vm.job,
          "is-need-expand": _vm.sopStateDialog.isNeedExpand
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.sopStateDialog, "visible", $event)
          },
          "update:isNeedExpand": function($event) {
            return _vm.$set(_vm.sopStateDialog, "isNeedExpand", $event)
          },
          "update:is-need-expand": function($event) {
            return _vm.$set(_vm.sopStateDialog, "isNeedExpand", $event)
          },
          handleClose: _vm.sopStateDialogClose
        }
      }),
      _vm.opVerifyFrameDialog.visible
        ? _c("op-verify-frame-dialog", {
            attrs: {
              visible: _vm.opVerifyFrameDialog.visible,
              "job-model": _vm.opVerifyFrameDialog.job || {},
              "batch-pass-audit": _vm.opVerifyFrameDialog.batchPassAudit,
              "submit-call-back": _vm.opVerifyFrameDialog.submitCallBack,
              "job-list": _vm.opVerifyFrameDialog.jobList || []
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.opVerifyFrameDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.rejectWindow.visible
        ? _c("op-verify-frame-reject", {
            attrs: {
              visible: _vm.rejectWindow.visible,
              "job-no": _vm.rejectWindow.jobNo,
              "reject-call-back": _vm.rejectWindow.rejectCallBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.rejectWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("estimate-validation-dialog", {
        ref: "estimateValidationDialog",
        attrs: {
          visible: _vm.estimateValidationDialog.visible,
          job: _vm.estimateValidationDialog.job,
          "estimate-profit-rate":
            _vm.estimateValidationDialog.estimateProfitRate,
          "tatol-profit": _vm.estimateValidationDialog.tatolProfit
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.estimateValidationDialog, "visible", $event)
          },
          callback: _vm.estimateValidationDialog.callback
        }
      }),
      _vm.confirmDialogWindow.visible
        ? _c("confirm-dialog-window", {
            attrs: {
              visible: _vm.confirmDialogWindow.visible,
              "message-title": _vm.confirmDialogWindow.messageTitle,
              content: _vm.confirmDialogWindow.content,
              "show-confirm-btn": _vm.confirmDialogWindow.showConfirmBtn,
              "confirm-call-back": _vm.confirmDialogWindow.confirmCallBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.confirmDialogWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.cooperationVerifyDialog.visible
        ? _c("cooperation-verify-dialog", {
            attrs: {
              visible: _vm.cooperationVerifyDialog.visible,
              "job-uuid": _vm.cooperationVerifyDialog.jobUuid,
              cooperate: _vm.cooperationVerifyDialog.cooperate,
              "submit-call-back": _vm.cooperationVerifyDialog.submitCallBack,
              "sea-job": _vm.cooperationVerifyDialog.job,
              config: _vm.cooperationVerifyDialog.config,
              editable: _vm.cooperationVerifyDialog.editable
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.cooperationVerifyDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              lob: _vm.lob,
              jobs: _vm.batchCheckingWindow.jobs,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack,
              "call-back2": _vm.batchCheckingWindow.callBack2,
              "new-job": _vm.batchCheckingWindow.newJob
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.checkingWindow.visible
        ? _c("checking-window", {
            attrs: {
              visible: _vm.checkingWindow.visible,
              lob: _vm.lob,
              job: _vm.job,
              "check-node": _vm.checkingWindow.checkNode,
              "call-back": _vm.checkingWindow.callBack,
              "call-back2": _vm.checkingWindow.callBack2,
              "new-job": _vm.checkingWindow.newJob
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingWindow, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }